export default __webpack_public_path__ + "static/media/BEL2018_Coastal_Swatch_Mega_Arbel_Amaretto.6843b38f.jpg";